/**
 * Enum represents all LaunchDarkly feature flags currently being used.
 * Flag keys are important and non-reusable unique identifiers.
 * The keys must provide information about the purpose and scope of a flag.
 * Suggested naming convention can be found here: https://launchdarkly.com/docs/guides/flags/flag-conventions#flag-kind-examples
 * Keys must be in kebab-case.
 */
export enum FeatureFlag {
  AMP_IS_ELEMENT_VISIBLE = 'amp-isElementVisible',
  RELEASE_NEW_BRAND_ICONS = 'release-new-brand-icons'
}
